/**
 * @file        src/pages/enquiry/groupRequestMeta.js
 * @description The words the Group Booking Requests screen and its detail
 *              modal both print — statuses, trip types, customer types, and the
 *              passenger line.
 *
 *              ONE COPY, because the two surfaces show the same lead: a status
 *              labelled "Quoted" in the table and "Quote sent" in the modal is
 *              two names for one state, and whichever a person reads first is
 *              the one they will look for afterwards.
 * @author      Kinetika Labs
 * @created     2026-09-25
 * @changelog
 *   - 2026-09-25 Claude — Initial (Query Management → Group Booking Requests).
 */

/** The pipeline, in the order a lead moves through it. */
export const STATUS_OPTIONS = [
  { value: 'new', label: 'New — nobody has picked this up' },
  { value: 'in_progress', label: 'In progress — working on it' },
  { value: 'quoted', label: 'Quoted — price sent to the customer' },
  { value: 'won', label: 'Won — they booked' },
  { value: 'lost', label: 'Lost — they did not' },
];

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'new', label: 'New' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'won', label: 'Won' },
  { value: 'lost', label: 'Lost' },
];

export const STATUS_LABEL = {
  new: 'New', in_progress: 'In progress', quoted: 'Quoted', won: 'Won', lost: 'Lost',
};

export const STATUS_TONE = {
  new: 'warn', in_progress: 'pend', quoted: 'pend', won: 'ok', lost: 'rej',
};

export const TRIP_OPTIONS = [
  { value: '', label: 'All trips' },
  { value: 'oneway', label: 'One way' },
  { value: 'return', label: 'Round trip' },
  { value: 'multicity', label: 'Multi-city' },
];
export const TRIP_LABEL = { oneway: 'One way', return: 'Round trip', multicity: 'Multi-city' };

export const CUSTOMER_OPTIONS = [
  { value: '', label: 'All customers' },
  { value: 'guest', label: 'Guest' },
  { value: 'retail', label: 'Retail' },
  { value: 'corporate', label: 'Corporate' },
];
export const CUSTOMER_LABEL = { guest: 'Guest', retail: 'Retail', corporate: 'Corporate' };

/**
 * "12A · 3C · 1I" — one line of the NON-ZERO classes. The stacked three-line
 * form costs a third of the visible rows and two of its lines usually read
 * zero, which is the same trap the flight search log's pax column fell into
 * (§15).
 */
export function paxLine(pax) {
  if (!pax) return null;
  const parts = [
    pax.adults ? `${pax.adults}A` : null,
    pax.children ? `${pax.children}C` : null,
    pax.infants ? `${pax.infants}I` : null,
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : null;
}
